/* ═══════════════════════════════════════════════════════════════════════════
   Águas de Ipanema — o que acontece DEPOIS de adicionar ao carrinho
   ═══════════════════════════════════════════════════════════════════════════
   Regra de negócio (2026-09-09, segunda versão): adicionar abre o
   mini-carrinho lateral, e é de lá que o cliente decide finalizar. Mesmo
   caminho de referência da ADA TINA:

       Adicionar → gaveta do carrinho → "Finalizar compra" → /checkout

   Isto SUBSTITUI a regra anterior do mesmo dia, que mandava direto para o
   checkout sem passar pela gaveta.

   Os formulários do tema (<form is="product-form">: PDP, quick buy,
   shop the look, product-item) já fazem esse fluxo sozinhos — por isso este
   arquivo não intercepta mais o submit deles. O que sobra aqui é o helper
   compartilhado para os botões que NÃO são formulário: o quick add e o CTA
   do card 2026, em snippets/product-card-2026.liquid.

   NOTA sobre o nome do arquivo: ele nasceu como "add-to-checkout" na regra
   antiga e continua com esse nome para não quebrar a referência no
   layout/theme.liquid nem deixar um asset órfão no tema publicado.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  if (window.__aipAddToCart) return;
  window.__aipAddToCart = true;

  function urlDoCarrinho() {
    var v = window.themeVariables && window.themeVariables.routes;
    return (v && v.cartUrl) ? v.cartUrl : '/cart';
  }

  /* Repete a sequência de eventos do <form is="product-form"> do tema, para
     que a gaveta se atualize e abra exatamente como nos demais caminhos:
       variant:added → cart:updated → cart:refresh { openMiniCart }
     `origem` é o elemento que disparou a ação; quando ele já está dentro de
     uma gaveta (ex.: cross-sell do próprio mini-carrinho), não reabrimos. */
  window.aipAposAdicionar = function (respostaAdd, origem) {
    var alvo = origem || document.documentElement;
    var variante = (respostaAdd && respostaAdd.items) ? respostaAdd.items[0] : respostaAdd;

    alvo.dispatchEvent(new CustomEvent('variant:added', {
      bubbles: true, detail: { variant: variante }
    }));

    var jaNaGaveta = !!(origem && origem.closest && origem.closest('.drawer'));

    return fetch(urlDoCarrinho() + '.js')
      .then(function (res) { return res.json(); })
      .then(function (carrinho) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true, detail: { cart: carrinho }
        }));

        /* O tema lê as seções pré-renderizadas quando elas vêm na resposta do
           /cart/add; sem elas, a própria gaveta busca /cart?section_id=… */
        if (respostaAdd && respostaAdd.sections) {
          carrinho.sections = respostaAdd.sections;
        }

        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { cart: carrinho, openMiniCart: !jaNaGaveta }
        }));

        return carrinho;
      });
  };
})();
